import { AgentDetailSection, AgentDetailSectionEnum } from "../../../../../../agentDetail.model";
import { BusinessPanel } from "./components/businessPanel/businessPanel.index";
import { ContractPanel } from "./components/contractPanel/contractPanel.index";
import { PersonalPanel } from "./components/personalPanel/personalPanel.index";

export const RIGHT_SECTION_TABS: Record<AgentDetailSection, React.ComponentType> = {
    [AgentDetailSectionEnum.PERSONAL_INFORMATION]: PersonalPanel,
    [AgentDetailSectionEnum.BUSINESS_INFORMATION]: BusinessPanel,
    [AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION]: ContractPanel,
};

export const HIDE_FOOTER_TABS = [
    AgentDetailSectionEnum.CONTRACT_AND_LICENSING_INFORMATION,
];

